import { createI18n } from 'vue-i18n'
const i18n = createI18n({
    locale: localStorage.getItem('lang') || 'zh',        //默认显示的语言 
    globalInjection: true, // 全局注册 $t方法
    messages: {
        zh: require('./zhCN'),    //引入语言文件
        en: require('./en')
    }
})
export default i18n;